import script from "./CompanyPostDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyPostDialog.vue?vue&type=script&setup=true&lang=js"

import "./CompanyPostDialog.vue?vue&type=style&index=0&id=6303baf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6303baf8"]])

export default __exports__